import React from "react";
import {withApollo} from "react-apollo";
import {Link} from 'react-router-dom';
import _ from "lodash";

import DashboardIcon from "@material-ui/icons/Dashboard";
import Tooltip from 'material-ui/Tooltip';
import withStyles from "material-ui/styles/withStyles";
import IconButton from "components/CustomButtons/IconButton.jsx";

import { downloadFile } from "lib/utils" ;
import Table from '../../elements/Table';
import GridContainer from "components/Grid/GridContainer";
import ItemGrid from "components/Grid/ItemGrid";
import IconCard from "components/Cards/IconCard";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { getProjectDetails } from "../graph";
import {projectsStyle} from '../style';
import ExportPinsModal from './ExportPinsModal';

import CustomStatsCard from "components/Cards/CustomStatsCard.jsx";
import NewStatsCard from "components/Cards/NewStatsCard.jsx";
import PhoneTalk from "@material-ui/icons/PhoneInTalk";

import Card from "material-ui/Card";
import CardContent from "material-ui/Card/CardContent";
import CardHeader from "material-ui/Card/CardHeader";
import CardActions from "material-ui/Card/CardActions";

import Typography from "material-ui/Typography";
import Avatar from "material-ui/Avatar";

import { getPinStatsQuery } from "views/stats/graph";
import Loading from "views/etc/Loading";

import Select from "react-select";
import { Line, Bar } from "react-chartjs-2";
import ProfileItems from "views/etc/ProfileItems.jsx";

import Person from "@material-ui/icons/Person";
import Group from "@material-ui/icons/Group";
import Check from "@material-ui/icons/Check";
import AccessTime from "@material-ui/icons/AccessTime";
import PhoneCallBack from "@material-ui/icons/RingVolume";
import LocationOn from "@material-ui/icons/LocationOn";

import Snackbar from "../../callform/components/CustomErrorSnackBar";

class ViewProject extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            loading: true,
            pid: this.props.match.params.id,
            pinData: {},
            selectedDate: 1, 
            completedData: {},
            minutesCollectedData: {},
            isLoadingPin: true
        };
        this.dateOptions = [{
            value: 0,
            label: 'Last 24 hours'
          },
          {
            value: 1,
            label: 'Last 7 days'
          },
          {
            value: 2,
            label: 'Last Week'
          },
          {
            value: 3,
            label: 'Last Month'
          },
          {
            value: 4,
            label: 'Last Year'
          },
        ];
    }
    componentDidMount(){
        this.getPinStats(this.state.pid, this.state.selectedDate);
    }
    componentDidUpdate(prevProps, prevState){
        if(this.props.getProjectDetails.loading == false && _.isEmpty(this.state.project)){
            this.setState({
                project: this.props.getProjectDetails.project,
                loading: false
            });
        }
    }
    getPinStats = (pid, dateFilter) => {
        this.setState({
            isLoadingPin: true
        });
        this.props.getPinStatsQuery({
            variables: {
              pid: pid,
              dateFilter: dateFilter
            }
          }).then((data) => {
            const items = JSON.parse(data.data.pinStats.jsonObject);
            const successRate = items.success_rate * 100;
            let pinData = {
              totalPinsCompleted: items.total_pins_completed,
              totalCallAttempts: items.total_call_attempts,
              totalCallSuccess: items.total_call_success,
              totalMinutesRecorded: items.total_minutes_recorded,
              totalCallSuccessRate: Math.round(successRate) / 100,
              durationHeaders: items.duration_headers,
              durations: JSON.parse(items.durations),
              completedHeaders :items.completed_headers,
              completed: JSON.parse(items.completed),
              totalPins: items.total_pins,
              totalUsers: items.total_users
            };

            let minutesGraph = {};
            let completedGraph = {};

            try{
                minutesGraph = {
                            labels: pinData.durationHeaders.slice(1,),
                            datasets: [{
                                    fill: false,
                                    label: "Minutes Collected",
                                    fillColor: "rgba(220,220,220,0.2)",
                                    strokeColor: "rgba(220,220,220,1)",
                                    pointColor: "rgba(220,220,220,1)",
                                    pointStrokeColor: "#fff",
                                    pointHighlightFill: "#fff",
                                    pointHighlightStroke: "rgba(220,220,220,1)",
                                    borderColor: [
                                        "rgb(242, 29, 29)"
                                    ],
                                    data: pinData.durations[0].slice(1,)
                                }]
                            };
            }
            catch(err){
                minutesGraph = {};
            }


            try{
                completedGraph = {
                            labels: pinData.completedHeaders.slice(1,),
                            datasets: [{
                                    fill: false,
                                    label: "Calls Completed",
                                    borderColor: [
                                        "rgb(102,0,102)"
                                    ],
                                    data: pinData.completed[0].slice(1,)
                                }]
                            };
            }
            catch(err){
                completedGraph = {};
            }

            this.setState({
              pinData: pinData,
              minutesCollectedData: minutesGraph,
              completedData: completedGraph,
              isLoadingPin: false
            });
          }).catch((error) => {
            this.setState({
              isLoadingPin: false
            });
          });
    }
    dateChange = (date) => {
        this.setState({selectedDate: date.value});
        this.getPinStats(this.state.pid, date.value);
    }

    render(){
        const { loading, pinData, selectedDate, minutesCollectedData, isLoadingPin, completedData, project } = this.state;
        const { classes } = this.props;
        let snackbar = null;
        if (project && !project.active) {
            snackbar = <Snackbar
                    formErrorMessage="WARNING: THIS PROJECT IS DEACTIVATED. Fwp Users under this project will not be able to login"
                    errorSnackbarOpen={true}
                    closeErrorSnackbar={()=>{return false}}
                />
        }

        return(
            <GridContainer justify="flex-start" direction="row" spacing={8}>
                {snackbar}
                <ItemGrid xs={9}>
                    <ItemGrid xs={12}>
                        {(loading) ? <Loading />  :
                        <IconCard 
                            icon={DashboardIcon}
                            title={<div>
                                    {project.name} 
                                    <div className="pull-right">
                                    <GridContainer>
                                    <Link to={`/projects/${project.pid}/pins`} style={{marginRight:"2.5px"}}>
                                        <IconButton color="primary" >
                                            <Tooltip
                                                id="tooltip-top"
                                                title="Pins"
                                                placement="top"
                                            ><LocationOn />
                                            </Tooltip>
                                        </IconButton>
                                    </Link>
                                    <Link to={`/users/project/${project.pid}`}>
                                        <IconButton color="primary" style={{marginRight:"2.5px"}}>
                                            <Tooltip
                                                id="tooltip-top"
                                                title="Users"
                                                placement="top"
                                            ><Person />
                                            </Tooltip>
                                        </IconButton>
                                    </Link>
                                    <Link to={`/projects/${project.pid}/groups`}>
                                        <IconButton color="primary">
                                            <Tooltip
                                                id="tooltip-top"
                                                title="Groups"
                                                placement="top"
                                            ><Group />
                                            </Tooltip>
                                        </IconButton>
                                    </Link>
                                    </GridContainer>
                                    </div>                          
                                    </div>}
                            content={
                                    <GridContainer justify="flex-start">
                                        <ItemGrid xs={12} />
                                        <ItemGrid xs={3}>
                                            <ProfileItems label={project.pid} title="Server ID" />
                                        </ItemGrid>
                                        <ItemGrid xs={3}>
                                            <ProfileItems label={project.manager} title="Manager" />
                                        </ItemGrid>
                                         <ItemGrid xs={3}>
                                            <ProfileItems label={`${project.language} - ${project.country}`} title="Language & Country" />
                                        </ItemGrid>
                                        <ItemGrid xs={2} />

                                        <ItemGrid xs={3}>
                                            <ProfileItems label={project.projid} title="Project ID" />
                                        </ItemGrid>
                                        <ItemGrid xs={6}>
                                            <ProfileItems label={project.extension} title="Extension" />
                                        </ItemGrid>
                                    </GridContainer>
                                }
                        />
                        }
                    </ItemGrid>
                    <ItemGrid xs={12}>
                        <GridContainer direction="row">
                            <ItemGrid xs={12}>
                                <Card>
                                    {(isLoadingPin) ? <Loading /> :
                                    <CardContent>
                                        {(_.isEmpty(minutesCollectedData)) ? <p>No data found</p> :
                                        <Line 
                                            data={ minutesCollectedData }
                                            width={600}
                                            height={250}
                                        /> 
                                        }
                                    </CardContent>
                                    }
                                </Card>
                            </ItemGrid>
                            <ItemGrid xs={12}>
                                <Card>
                                    <CardContent>
                                        {(_.isEmpty(completedData)) ? <p>No data found</p> :
                                        <Line 
                                            data={completedData}
                                            width={600}
                                            height={250}
                                        />
                                        }
                                    </CardContent>
                                </Card>
                            </ItemGrid>
                        </GridContainer>
                    </ItemGrid>
                    
                </ItemGrid>
                <ItemGrid xs={3}>
                    <GridContainer spacing={8} justify="center" direction="column">
                        <ItemGrid>
                            <Select 
                                placeholder="Filter by.."
                                options={this.dateOptions}
                                value={selectedDate}
                                onChange={this.dateChange}
                            />
                        </ItemGrid>
                        <ItemGrid xs={12}>
                            <NewStatsCard
                                title="Success Rate"
                                icon={Check}
                                iconColor="green"
                                statNum={`${pinData.totalCallSuccessRate}%`}
                            />
                        </ItemGrid>
                        <ItemGrid xs={12}>
                            <NewStatsCard
                                title="Minutes Recorded"
                                iconColor="green"
                                icon={AccessTime}
                                statNum={pinData.totalMinutesRecorded}
                            />
                        </ItemGrid>
                        <ItemGrid xs={12}>
                            <NewStatsCard
                                title="Call Attempts"
                                iconColor="red"
                                icon={PhoneCallBack}
                                statNum={pinData.totalCallAttempts}
                            />
                        </ItemGrid>
                        <ItemGrid xs={12}>
                            <NewStatsCard
                                title="Successful Calls"
                                icon={PhoneTalk}
                                iconColor="red"
                                statNum={pinData.totalCallSuccess}
                            />
                        </ItemGrid>
                        <ItemGrid xs={12}>
                            <NewStatsCard
                                title="Total Users"
                                icon={Group}
                                iconColor="purple"
                                statNum={pinData.totalUsers}
                            />
                        </ItemGrid>
                        <ItemGrid xs={12}>
                            <NewStatsCard
                                title="Total Pins"
                                icon={LocationOn}
                                iconColor="purple"
                                statNum={pinData.totalPins}
                            />
                        </ItemGrid>
                    </GridContainer>
                </ItemGrid>
            </GridContainer>
        )
    }
}
export default withStyles(projectsStyle)((getProjectDetails)(ViewProject))





// WEBPACK FOOTER //
// ./src/views/projects/components/ViewProject.js